if ( window.location.href.indexOf("127.0.0.1") === -1) {
	(function (m, e, t, r, i) {
		m[i] = m[i] || function () {
			(m[i].a = m[i].a || []).push(arguments)
		};
		m[i].l = 1 * new Date();
		for (var j = 0; j < document.scripts.length; j++) {
			if (document.scripts[j].src === r) {
				return;
			}
		}
		var k = e.createElement(t), a = e.getElementsByTagName(t)[0], k_async = 1, k_src = r;
		k.async = Boolean(k_async);
		k.src = k_src;
		a.parentNode?.insertBefore(k, a)
	})(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js?id=106096124', 'ym');

	(window).ym(106096124, 'init', {
		ssr: true,
		webvisor: true,
		clickmap: true,
		ecommerce: "dataLayer",
		accurateTrackBounce: true,
		trackLinks: true
	});
}